<div class="animation-side-panel">
  <div class="panel-header">
    <h3>Animations</h3>
  </div>

  <!-- <ng-container *ngIf="areThereSelectedShapes$ | async; else slideAnimation"> -->

  <div *ngIf="animationSidePanelState$ | async as state" class="body">
    <ng-container *ngIf="state.type == 'multi-selection'; else form">
      ~
    </ng-container>

    <ng-template #form>
      <div class="header">Appear</div>
      <ng-container *ngIf="state.type == 'container' || state.type == 'text'">
        <div class="sub-header">Mode</div>
        <div
          *ngIf="appearModeAnimation$ | async as appearContainerAnimation"
          class="option-container"
        >
          <div
            (click)="selectContainerTransition('shift')"
            [class.selected]="
              !appearContainerAnimation ||
              appearContainerAnimation.mode == 'shift'
            "
          >
            shift
          </div>
          <div
            (click)="selectContainerTransition('continous-shift')"
            [class.selected]="
              appearContainerAnimation.mode == 'continous-shift'
            "
          >
            continous shift
          </div>
          <div
            (click)="selectContainerTransition('fixed')"
            [class.selected]="appearContainerAnimation.mode == 'fixed'"
          >
            fixed
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="state.type != 'container'">
        <div class="sub-header">Float</div>
        <div class="option-container">
          <div (click)="selectFloatAppearMode('left')">Left</div>
          <div (click)="selectFloatAppearMode('right')">Right</div>
          <div (click)="selectFloatAppearMode('top')">Top</div>
          <div (click)="selectFloatAppearMode('bottom')">Bottom</div>
        </div>
      </ng-container>
      <ng-container *ngIf="state.type != 'container'">
        <div class="sub-header">Scale</div>
        <div class="option-container">
          <div
            (click)="selectScaleMode('grow')"
            [class.selected]="state.appear.scale == 'grow'"
          >
            grow
          </div>
          <div
            (click)="selectScaleMode('shrink')"
            [class.selected]="state.appear.scale == 'shrink'"
          >
            shrink
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="state.type == 'text'">
        <div class="sub-header">By</div>
        <div *ngIf="appearTextAnimation$ | async as appearTextAnimation">
          <div class="option-container">
            <div
              (click)="selectTextAnimationBy('line')"
              [class.selected]="
                !appearTextAnimation.by || appearTextAnimation.by == 'line'
              "
            >
              line
            </div>
            <div
              (click)="selectTextAnimationBy('word')"
              [class.selected]="appearTextAnimation.by == 'word'"
            >
              word
            </div>
            <div
              (click)="selectTextAnimationBy('letter')"
              [class.selected]="appearTextAnimation.by == 'letter'"
            >
              letter
            </div>
          </div>
        </div>
      </ng-container>
    </ng-template>
  </div>
  <div class="preview-container">
    <div class="flex-row gap-8" (mouseenter)="playSlidePreview()">
      <div class="preview">Preview</div>
      <nw-icon
        type="play_arrow"
        [size]="18"
        color="white"
        [outlined]="true"
      ></nw-icon>
    </div>
  </div>
  <ng-container *ngIf="false">
    <div class="panel-content">
      <div class="section-container">
        <div class="header">Appear</div>

        <ng-container *ngIf="appearDefined$ | async; else addAppear">
          <div class="row">
            <div class="flex-row gap-8">
              <div class="key">type</div>
              <div *ngIf="(appearTypeValues$ | async).length > 1" class="mixed">
                ~
              </div>
            </div>

            <div class="value flex-row gap-12">
              <div
                class="type"
                [class.selected-type]="isFadeSelected$ | async"
                (click)="saveType('fade')"
              >
                fade
              </div>
              <div
                class="type"
                [class.selected-type]="isMaskSelected$ | async"
                (click)="saveType('mask')"
              >
                mask
              </div>
            </div>
          </div>

          <div
            class="row space-between start"
            *ngIf="motionValues$ | async as motionValues"
          >
            <div class="flex-row gap-8">
              <div class="key">motion</div>
              <div *ngIf="motionValues.length > 1" class="mixed">~</div>
            </div>
            <div class="flex-column gap-6">
              <div
                class="motion"
                [class.selected-motion]="motionValues.length == 0"
                (click)="resetMotion()"
              >
                none
              </div>
              <div
                [class.selected-motion]="motionValues.includes('float')"
                class="flex-column gap-4 motion"
                (click)="setMotion('float', 'top')"
              >
                <div>float</div>
                <div class="flex-row gap-8">
                  <img
                    src="assets/icons/animation/left_appear.svg"
                    alt=""
                    (click)="
                      setMotion('float', 'left'); $event.stopPropagation()
                    "
                  />
                  <img
                    src="assets/icons/animation/top_appear.svg"
                    alt=""
                    (click)="
                      setMotion('float', 'top'); $event.stopPropagation()
                    "
                  />
                  <img
                    src="assets/icons/animation/right_appear.svg"
                    alt=""
                    (click)="
                      setMotion('float', 'right'); $event.stopPropagation()
                    "
                  />
                  <img
                    src="assets/icons/animation/bottom_appear.svg"
                    alt=""
                    (click)="
                      setMotion('float', 'bottom'); $event.stopPropagation()
                    "
                  />
                </div>
              </div>
              <div
                class="flex-column gap-4 motion"
                [class.selected-motion]="motionValues.includes('scale')"
                (click)="setMotion('scale', 'top')"
              >
                <div>scale</div>
                <div class="flex-row gap-12">
                  <img
                    src="assets/icons/animation/zoom_in_appear.svg"
                    alt=""
                    (click)="
                      setMotion('float', 'bottom'); $event.stopPropagation()
                    "
                  />
                  <img
                    src="assets/icons/animation/zoom_out_appear.svg"
                    alt=""
                    (click)="
                      setMotion('float', 'bottom'); $event.stopPropagation()
                    "
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row start" *ngIf="isTextShapePresent$ | async">
            <div class="flex-row gap-8">
              <div class="key">text</div>
              <div *ngIf="(appearTypeValues$ | async).length > 1" class="mixed">
                ~
              </div>
            </div>

            <div class="value flex-column gap-12">
              <div
                class="type"
                [class.selected-type]="isByLetter$ | async"
                (click)="setTextBy('letter')"
              >
                by letter
              </div>
              <div
                class="type"
                [class.selected-type]="isByWord$ | async"
                (click)="setTextBy('word')"
              >
                by word
              </div>
              <div
                class="type"
                [class.selected-type]="isByLine$ | async"
                (click)="setTextBy('line')"
              >
                by line
              </div>
            </div>
          </div>

          <!-- <div class="flex-row gap-12"></div>

          <div>Letter</div>

          <div class="flex-column gap-8">
            <div class="flex-row gap-8">
              <img src="assets/icons/animation/text_animation_1.svg" alt="" />
              <img src="assets/icons/animation/text_animation_2.svg" alt="" />
            </div>
            <div class="flex-row gap-8">
              <img src="assets/icons/animation/text_animation_3.svg" alt="" />
              <img src="assets/icons/animation/text_animation_4.svg" alt="" />
            </div>
          </div>

          <div>Word</div>

          <div class="flex-column gap-8">
            <div class="flex-row gap-8">
              <img src="assets/icons/animation/word_animation_1.svg" alt="" />
              <img src="assets/icons/animation/word_animation_2.svg" alt="" />
            </div>
            <div class="flex-row gap-8">
              <img src="assets/icons/animation/word_animation_3.svg" alt="" />
            </div>
          </div>

          <div
            class="footer border-top"
            style="font-size: 16px"
            (click)="removeAppearAnimation()"
          >
            -
          </div> -->
        </ng-container>
        <ng-template #addAppear>
          <div class="footer pointer" (click)="addAppearAnimation()">+</div>
        </ng-template>
      </div>

      <!-- <div class="ai-selector">
      <select class="ai-model-select">
        <option value="openai">OpenAI</option>
        <option value="claude">Claude</option>
      </select>
    </div>
    
    <div class="ai-input-area">
      <textarea
        placeholder="Enter your animation instructions here..."
      ></textarea>
    </div>

    <div class="animation-controls">
      <button class="generate-btn">Generate Animation</button>
      <button class="apply-btn">Apply</button>
    </div> -->
    </div>
  </ng-container>

  <ng-template #slideAnimation>
    <div class="p-8 flex-column gap-8 container">
      <div class="header">Appear</div>

      <div class="flex-row space-between">
        <div>Duration</div>
        <input />
      </div>
      <div class="flex-row space-between">
        <div>Overlap</div>
        <input />
      </div>
    </div>
  </ng-template>
</div>
